import script from "./CarrosselMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./CarrosselMobile.vue?vue&type=script&setup=true&lang=js"

import "./CarrosselMobile.vue?vue&type=style&index=0&id=d768f91e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d768f91e"]])

export default __exports__